import { CssBaseline } from '@mui/material';
import { useRoutes } from 'react-router-dom';
import { MatxTheme } from './components';
import { SettingsProvider } from './contexts/SettingsContext';
import routes from './routes';
import { Provider } from 'react-redux';
import store from './contexts/store';
import FinancialYearInitializer from './components/FinancialYearInitializer';

const App = () => {
  const content = useRoutes(routes);

  return (
    <SettingsProvider>
      <Provider store={store}>
        <FinancialYearInitializer>
          <MatxTheme>
            <CssBaseline />
            {content}
          </MatxTheme>
        </FinancialYearInitializer>
      </Provider>
    </SettingsProvider>
  );
};

export default App;
